import { getLinkedFirm } from "../../sessionStorage/sessionStorage";
import { useGetAiStatusQuery } from "../../slices/AiSlice";

/** The firm's AI status; `isOn` = set up on the server and switched on. */
export const useAiStatus = () => {
  const orgId: string = getLinkedFirm()?.orgId || "";
  const query = useGetAiStatusQuery({ orgId }, { skip: !orgId });
  const status = query.data;
  return {
    ...query,
    orgId,
    status,
    isOn: !!status?.configured && !!status?.enabled,
  };
};
